import React from 'react';
import { useFunnel } from '../../contexts/FunnelContext';
import type { AccessInfo } from '../../types/funnel';
import { AccessEditor } from './AccessEditor';
import { StepHeading } from './StepHeading';
import { HelpAnswers } from './HelpAnswers';
import { BrandPhoto } from './BrandPhoto';
const note = {
  en: 'Stairs, elevators and long walks change how long a move takes and how we protect your home. That’s why we ask about each place separately.',
  es: 'Las escaleras, los elevadores y las caminatas largas cambian la duración de la mudanza y cómo protegemos su hogar. Por eso preguntamos por cada lugar por separado.'
};
const stopTitle = {
  en: (n: number, street: string) => `Stop ${n}${street ? `: ${street}` : ''}`,
  es: (n: number, street: string) => `Parada ${n}${street ? `: ${street}` : ''}`
};
export function StepAccess() {
  const {
    t,
    lang,
    data,
    update,
    updateAccess
  } = useFunnel();
  const multiUnit = data.homeType === 'apartment' || data.homeType === 'office';
  const patchStopAccess = (id: string, p: Partial<AccessInfo>) => update({
    stops: data.stops.map(s => s.id === id ? {
      ...s,
      access: {
        ...s.access,
        ...p
      }
    } : s)
  });
  return <div data-id="element-636" data-mp="2o720wo2sgrzn">
      <StepHeading title={t('accessTitle')} intro={t('accessIntro')} data-id="element-637" data-mp="2o6sl1tbgk17o" />
      <div className="mb-10 grid grid-cols-[1fr_1fr] gap-3 sm:grid-cols-[160px_160px_1fr] sm:items-center sm:gap-5" data-id="element-638" data-mp="2o4zesf4rbj07">
        <BrandPhoto role="stairs_access" alt="Crew member handling protected furniture at a staircase" className="aspect-[3/4] w-full rounded-xl" data-id="element-639" data-mp="3gvr4ctrbh9ek" />
        {multiUnit ? <BrandPhoto role="elevator_access" alt="Crew member moving protected furniture at a building elevator" className="aspect-[3/4] w-full rounded-xl" data-id="element-640" data-mp="3bxfsyeldiqu8" /> : <BrandPhoto role="floor_protection" alt="Staircase protected with moving blankets" className="aspect-[3/4] w-full rounded-xl" data-id="element-641" data-mp="32v6lxypbdfll" />}
        <p className="col-span-2 text-[15px] leading-relaxed text-ink-600 sm:col-span-1" data-id="element-642" data-mp="1wdjjzxt1qpyw">{note[lang]}</p>
      </div>
      <div className="space-y-10" data-id="element-643" data-mp="1sy886au7vu0s">
        <AccessEditor title={t('originHome')} access={data.origin} onChange={p => updateAccess('origin', p)} multiUnit={multiUnit} data-id="element-644" data-mp="1sz9w3fwc0azx" />
        {data.stops.map((s, i) => <React.Fragment key={s.id} data-id="element-645" data-mp="1jxtkj4ts62u4" data-mpi={i}>
            <div className="border-t border-ink-200" data-id="element-646" data-mp="1jwqrorcwdqbk" />
            <AccessEditor title={stopTitle[lang](i + 1, s.street)} access={s.access} onChange={p => patchStopAccess(s.id, p)} multiUnit data-id="element-647" data-mp="1nycdx3bbngyf" />
          </React.Fragment>)}
        <div className="border-t border-ink-200" data-id="element-648" data-mp="1a5nw252qm3jo" />
        <AccessEditor title={t('destHome')} access={data.destination} onChange={p => updateAccess('destination', p)} multiUnit={multiUnit} data-id="element-649" data-mp="1eyz3o8fdiocn" />
      </div>
      <HelpAnswers screen="stepAccess" className="mt-10" data-id="element-650" data-mp="158dxnzxdehjp" />
    </div>;
}